define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/config",
	"csi/xml"
], function(declare,Controller,config,xml) {

	return declare(Controller, {
		getActionView: function(/*ViewRef*/vr) {
			var theme = this.getNode();
			var themeBOMType = theme.ThemeBOMType;

			return (!config.hasSubtype("ApparelBOM") || xml.isValidURL(themeBOMType)) ? null : this.inherited(arguments);
		}
	});
});